@if (hasDuplicates) {
  <div class="duplicate-patients p-3" [class.has-tabs]="hasTabs">
    <div class="mat-container">
        <div class=" d-flex flex-row align-items-center justify-content-between">
          <span>The following {{duplicates.length}} patient(s) match your current input.Please verify you are not adding a duplicate patient</span>
          @if (!duplicatesOpen) {
            <button mat-icon-button type="button" (click)="toggleIsOpen()">
              <mat-icon class="md-20">arrow_drop_down</mat-icon>
            </button>
          }
          @if (duplicatesOpen) {
            <button mat-icon-button type="button" (click)="toggleIsOpen()">
              <mat-icon class="md-20">arrow_drop_up</mat-icon>
            </button>
          }
        </div>
        <mat-list class="duplicates" [class.visible]="duplicatesOpen">
          @for (duplicate of duplicates; track duplicate.profileId; let i = $index) {
            <mat-list-item>
              <div class="ms-2 me-auto d-flex flex-row align-items-center justify-content-between w-100">
                <div class="fw-bold">{{duplicate.profileId}} {{duplicate.displayName}} {{duplicate.identityNumber}}</div>
                <button mat-button (click)="editPatient(i)">Edit</button>
              </div>
            </mat-list-item>
          }
        </mat-list>
    </div>
  </div>
}
@if (saveError) {
  <app-alert type="danger" [message]="saveError" [dismissible]="true" (dismissed)="dismissError()" [class.has-tabs]="hasTabs"></app-alert>
}
<mat-card appearance="outlined" class="mb-3" [class.valid]="formValid && validate" [class.invalid]="!formValid && validate">
  <mat-card-content>
    @if (validationEnabled && !formValid) {
      <p class="card-text mat-text-warn" (click)="toggleFullErrorMessage()">Please correct any errors highlighted in red on the form.</p>
    }
    @if (showFullErrorMessage) {
      <ul class="full-error-message">
        @for (error of fullFormError; track $index) {
          <li class="card-text mat-text-warn">{{error.key}}: {{error.control.errors | json}}</li>
        }
      </ul>
    }
    @if (form) {
      <form class="form" [formGroup]="form" [class.form-validated]="validationEnabled">
      <input type="hidden" [name]="'profilePictureUrl'"/>
      @if (isEditForm) {
        <input type="hidden" [formControlName]="'status'">
      }
        <div class="row">

          <div class="col-sm-12">
            <div class="d-flex flex-row align-items-center justify-content-between">
              <h2 class="mb-3">Name</h2>
              @if (!isEditForm) {
                <button mat-stroked-button color="warn"  (confirm)="clearSavedFormData()" appConfirmationDialog [confirmMessage]="'Are you sure you wish to clear all form data? This will reset the form and remove any saved data.'">
                  Clear Form
                </button>
              }
            </div>
          </div>
        </div>
    <div class="row mb-3">
      <div class="col-sm-12 col-md-6">
        <mat-form-field appearance="fill" color="primary" class="w-100">
          <mat-label>Select Title</mat-label>
          <mat-select formControlName="title">
            @for (title of titles; track title.value) {
              <mat-option [value]="title.value">{{title.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" color="primary" class="w-100">
          <mat-label>First Name</mat-label>
          <input matInput formControlName="firstName" type="text"/>
        </mat-form-field>
        <mat-form-field appearance="fill" color="primary" class="w-100">
          <mat-label>Surname</mat-label>
          <input matInput formControlName="surname" type="text"/>
        </mat-form-field>
        <mat-form-field appearance="fill" color="primary" class="w-100">
          <mat-label>Middle Name(s)</mat-label>
          <input matInput formControlName="middleNames" type="text"/>
        </mat-form-field>
        <mat-form-field appearance="fill" color="primary" class="w-100">
          <mat-label>Nickname</mat-label>
          <input matInput formControlName="nickname" type="text"/>
        </mat-form-field>
      </div>
      <div class="col-sm-12 col-md-6">
        @if (isEditForm) {
          <app-allergies-widget/>
        }
      </div>
    </div>
    <mat-divider inset></mat-divider>
    <div class="row mb-3">
      <div class="col-12">
        <h2 class="mb-3">Identification</h2>
        <div class="row">
          <div class="col-12 col-md-6">
            @if (useFileNumberAsPatientProfileId) {
              <mat-form-field appearance="fill" color="primary" class="w-100">
                <mat-label>Existing File Number</mat-label>
                <input matInput formControlName="fileNumber" type="text"/>
              </mat-form-field>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Identity Number</mat-label>
              <input matInput formControlName="identityNumber" type="text"/>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Confirm Identity Number</mat-label>
              <input matInput formControlName="identityNumberConfirmation" type="text"/>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Date Of Birth</mat-label>
              <input matInput [min]="minDobValue" [max]="maxDobValue" [matDatepicker]="picker" formControlName="dateOfBirth" />
              <mat-datepicker  #picker></mat-datepicker>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Passport Number</mat-label>
              <input matInput formControlName="passportNumber" type="text"/>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Confirm Passport Number</mat-label>
              <input matInput formControlName="passportNumberConfirmation" type="text"/>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <mat-divider inset></mat-divider>
    <div class="row mb-3">
      <div class="col-12">
        <h2 class="mb-3">Demographics</h2>
        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Select Gender</mat-label>
              <mat-select formControlName="gender">
                @for (option of gender; track option.value) {
                  <mat-option [value]="option.value">{{option.text}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Select Language</mat-label>
              <mat-select formControlName="homeLanguage">
                @for (option of languages; track option.value) {
                  <mat-option [value]="option.value">{{option.text}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Select Race</mat-label>
              <mat-select formControlName="race">
                @for (option of races; track option.value) {
                  <mat-option [value]="option.value">{{option.text}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <mat-divider inset></mat-divider>
    <div class="row mb-3">
      <div class="col-12">
        <h2 class="mb-3">Contact Details</h2>
        @for (contactNumberFormGroup of contactNumbers.controls; track $index; let i = $index) {
          <patient-contact-form [controlFormGroup]="contactNumberFormGroup" [index]="i" (delete)="removeContactDetail($event)"
                                [deleteEnabled]="contactNumbers.controls.length > 1"></patient-contact-form>
        }
        <div class="row">
          <div class="col-12 col-md-6">
            <button mat-button color="primary" class="w-100" (click)="addContactDetail()">Add Phone Number</button>
          </div>
        </div>
      </div>
      <mat-divider inset class="w-50"></mat-divider>
      <div class="row">
        <div class="col-12">
          <h2 class="mb-3">Email Address Details</h2>
          @for (emailAddressFormGroup of emailAddresses.controls; track $index; let i = $index) {
            <patient-email-form [controlFormGroup]="emailAddressFormGroup" [index]="i" (delete)="removeEmailAddress($event)"
                                [deleteEnabled]="emailAddresses.controls.length > 1"></patient-email-form>
          }
          <div class="row">
            <div class="col-12 col-md-6">
              <button mat-button color="primary" class="w-100" (click)="addEmailAddress()">Add Email Address</button>
            </div>
          </div>
        </div>
      </div>
      <mat-divider inset class="w-50"></mat-divider>
      <div class="row">
        <div class="col-12">
          <h2 class="mb-3">Address Details</h2>
          @for (addressFormGroup of addressDetails.controls; track $index; let i = $index) {
            <patient-address-form [controlFormGroup]="addressFormGroup" [index]="i" (delete)="removeAddress($event)"
                                  [deleteEnabled]="addressDetails.controls.length > 1"></patient-address-form>
          }
          <div class="row">
            <div class="col-12 col-md-6">
              <button mat-button color="primary" class="w-100" (click)="addAddress()">Add Address</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="text-center w-50" [class.mat-text-warn]="validationEnabled && hasContactMethodError">At least one contact method is required</p>
    <mat-divider inset></mat-divider>
    <div class="row mb-3">
      <div class="col-sm-12">
        <h2>Secondary Contact Details</h2>
        @for (secondaryContactFormGroup of secondaryContacts.controls; track $index; let i = $index) {
          <app-secondary-contact-form [index]="i" [controlForm]="secondaryContactFormGroup" [validate]="validate" (delete)="removeSecondaryContactDetail(i)"
                                      [deleteEnabled]="secondaryContacts.controls.length > 1"></app-secondary-contact-form>
        }
        <div class="row">
          <div class="col-12 col-md-6">
            <button mat-button color="primary" class="w-100" (click)="addSecondaryContactDetail()">Add Secondary Contact</button>
          </div>
        </div>
      </div>
    </div>
    <mat-divider inset></mat-divider>
    <div class="row mb-3">
      <div class="col-sm-12 col-md-6">
        <h2>Family Doctor's Details</h2>
        <app-mat-autocomplete placeholder="Search Doctors" [searchObservable]="searchDoctors"
                              [addItemCardText]="'Click here to add a new doctor.'" #appMatAutocompleteComponent
                              [displayResultsCardTemplate]='doctorsTemplate' (addNewItem)="addNewDoctor()" [alwaysShowAddCard]="true"
                              (itemSelected)="familyDoctorSelected($event)"></app-mat-autocomplete>
        <ng-template #doctorsTemplate let-result="result" let-queryText="queryText">
          <div class="col-12">
            <div class="row">
              <div class="col-6"><span class="py-1 px-3 mb-0 fw-bold" [innerHtml]="result.name | textHighlight: queryText"></span></div>
              <div class="col-3"><span class="py-1 px-3 mb-0" [innerHtml]="result.practiceNumber | textHighlight: queryText"></span></div>
              <div class="col-3"><span class="py-1 px-3 mb-0" [innerHtml]="result.tel | textHighlight: queryText"></span></div>
            </div>
          </div>
        </ng-template>
      </div>
      <div class="col-sm-12 col-md-6">
        <h2>Referring Doctor's Details</h2>
        <app-mat-autocomplete placeholder="Search Doctors" [searchObservable]="searchDoctors"
                              [addItemCardText]="'Click here to add a new doctor.'" #appMatAutocompleteComponent
                              [displayResultsCardTemplate]='doctorsTemplate' (addNewItem)="addNewDoctor()" [alwaysShowAddCard]="true"
                              (itemSelected)="referringDoctorSelected($event)"></app-mat-autocomplete>
        <ng-template #doctorsTemplate let-result="result" let-queryText="queryText">
          <div class="col-12">
            <div class="row">
              <div class="col-6"><span class="py-1 px-3 mb-0 fw-bold" [innerHtml]="result.name | textHighlight: queryText"></span></div>
              <div class="col-3"><span class="py-1 px-3 mb-0" [innerHtml]="result.practiceNumber | textHighlight: queryText"></span></div>
              <div class="col-3"><span class="py-1 px-3 mb-0" [innerHtml]="result.tel | textHighlight: queryText"></span></div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        @for (doctor of familyDoctors.controls; track $index; let i = $index) {
          <app-doctor-display-card [controlFormGroup]="doctor" [index]="i" (edit)="editFamilyDoctor($event)" (delete)="removeFamilyDoctor($event)"></app-doctor-display-card>
        }
        @if (familyDoctors.controls.length===0) {
          <div class="px-3 pb-3 w-100 text-center">
            <span>No family doctors have been added to this patient.</span>
          </div>
        }
      </div>
      <div class="col-12 col-md-6">
        @for (doctor of referringDoctors.controls; track $index; let i = $index) {
          <app-doctor-display-card [controlFormGroup]="doctor" [index]="i" (edit)="editReferringDoctor($event)" (delete)="removeReferringDoctor($event)"></app-doctor-display-card>
        }
        @if (referringDoctors.controls.length===0) {
          <div class="px-3 pb-3 w-100 text-center">
            <span>No referring doctors have been added to this patient.</span>
          </div>
        }
      </div>
    </div>
    <mat-divider inset></mat-divider>
    <div class="row mb-3" [formGroup]="billingContact">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h2 class="mb-0">Person Responsible For Payment</h2>
            <button mat-flat-button color="primary" (click)="setBillingDetailsToPatientDetails()">Same As Patient</button>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <mat-form-field appearance="fill" color="primary" class="w-100">
                <mat-label>First Name</mat-label>
                <input matInput formControlName="billingContactFirstName" type="text"/>
              </mat-form-field>
              <mat-form-field appearance="fill" color="primary" class="w-100">
                <mat-label>Surname</mat-label>
                <input matInput formControlName="billingContactSurname" type="text"/>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <mat-form-field appearance="fill" color="primary" class="w-100">
                <mat-label>Identity Number</mat-label>
                <input matInput formControlName="billingContactIdentityNumber" type="text"/>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-6">
              <mat-form-field appearance="fill" color="primary" class="w-100">
                <mat-label>Confirm Identity Number</mat-label>
                <input matInput formControlName="billingContactIdentityNumberConfirmation" type="text"/>
              </mat-form-field>
            </div>
          </div>
        </div>
      <div class="row">
        <div class="col-12">
          <h4 class="mb-3">Contact Details</h4>
          @for (contactNumberFormGroup of billingContactContactNumbers.controls; track $index; let i = $index) {
            <patient-contact-form [controlFormGroup]="contactNumberFormGroup" [index]="i" (delete)="removeBillingContactContactDetail($event)"
                                  [deleteEnabled]="billingContactContactNumbers.controls.length > 1"></patient-contact-form>
          }
          <div class="row">
            <div class="col-12 col-md-6">
              <button mat-button color="primary" class="w-100" (click)="addBillingContactContactDetail()">Add Phone Number</button>
            </div>
          </div>
        </div>
        <mat-divider inset class="w-50"></mat-divider>
        <div class="row">
          <div class="col-12">
            <h4 class="mb-3">Email Address Details</h4>
            @for (emailAddressFormGroup of billingContactEmailAddresses.controls; track $index; let i = $index) {
              <patient-email-form [controlFormGroup]="emailAddressFormGroup" [index]="i" (delete)="removeBillingContactEmailAddress($event)"
                                  [deleteEnabled]="billingContactEmailAddresses.controls.length > 1"></patient-email-form>
            }
            <div class="row">
              <div class="col-12 col-md-6">
                <button mat-button color="primary" class="w-100" (click)="addBillingContactEmailAddress()">Add Email Address</button>
              </div>
            </div>
          </div>
        </div>
        <mat-divider inset class="w-50"></mat-divider>
        <div class="row">
          <div class="col-12">
            <h4 class="mb-3">Address Details</h4>
            @for (addressFormGroup of billingContactAddressDetails.controls; track $index; let i = $index) {
              <patient-address-form [controlFormGroup]="addressFormGroup" [index]="i" (delete)="removeBillingContactAddress($event)"
                                    [deleteEnabled]="billingContactAddressDetails.controls.length > 1"></patient-address-form>
            }
            <div class="row">
              <div class="col-12 col-md-6">
                <button mat-button color="primary" class="w-100" (click)="addBillingContactAddress()">Add Address</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="text-center w-50" [class.mat-text-warn]="validationEnabled && hasBillingContactMethodError">At least one billing contact method is required</p>
    <mat-divider inset></mat-divider>
    <div class="mb-3" [formGroup]="medicalAid">
      <h2>Medical Aid Details</h2>
      <input type="hidden" [name]="'destinationCode'"/>
      <input type="hidden" [name]="'scheme'"/>
      <input type="hidden" [name]="'schemeId'"/>
      @if (!hasScheme) {
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <app-mat-autocomplete placeholder="Search Schemes" (itemSelected)="setMedicalScheme($event)" [searchObservable]="searchSchemes"
                                  [displayResultsCardTemplate]='schemeTemplate' [isInvalid]="!!medicalAid.get('schemeId').errors?.['apiError']"></app-mat-autocomplete>
            <ng-template #schemeTemplate let-result="result" let-queryText="queryText">
              <div class="p-2">
                <h2 class="mb-1" [innerHtml]="'Name: ' + result.name | textHighlight: queryText"></h2>
                <p class="mb-1">Administrator: {{result.administrator}}</p>
              </div>
            </ng-template>
            @if (medicalAid.get('schemeId').errors?.['apiError']) {
              <app-alert type="danger" [message]="medicalAid.get('schemeId').errors?.['apiError']" [dismissible]="false"></app-alert>
            }
          </div>
        </div>
      }
      @if (hasScheme) {
        <div class="row">
          <div class="col-sm-12 col-md-6">
            @if (medicalAid.get('schemeId').value === 0) {
              <div class="alert alert-warning mb-3 d-flex flex-row align-items-center mat-text-warn justify-content-center">
                <mat-icon class="me-2">warning</mat-icon>
                Warning: Invalid or unused scheme. Please remove and re-add the medical aid scheme.
              </div>
            }
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Medical Aid</mat-label>
              <input matInput formControlName="scheme" type="text" readonly/>
              <button matSuffix mat-icon-button (click)="clearMedicalScheme()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
      }
      <div class="row">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="fill" color="primary" class="w-100">
            <mat-label>Medical Aid Plan</mat-label>
            <input matInput formControlName="plan" type="text"/>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="fill" color="primary" class="w-100">
            <mat-label>Medical Aid Number</mat-label>
            <input matInput formControlName="medicalAidNumber" type="text"/>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="fill" color="primary" class="w-100">
            <mat-label>Dependant Code</mat-label>
            <input matInput formControlName="dependantCode" type="text"/>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="fill" color="primary" class="w-100">
            <mat-label>Main Member&apos;s First Name</mat-label>
            <input matInput formControlName="mainMembersFirstName" type="text"/>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="fill" color="primary" class="w-100">
            <mat-label>Main Member&apos;s Surname</mat-label>
            <input matInput formControlName="mainMembersSurname" type="text"/>
          </mat-form-field>
        </div>
      </div>
    </div>
    @if (!useFileNumberAsPatientProfileId) {
      <mat-divider inset></mat-divider>
      <div class="row">
        <div class="col-12 col-md-6">
          <h2>Bookkeeping</h2>
          <mat-form-field appearance="fill" color="primary" class="w-100">
            <mat-label>Existing File Number</mat-label>
            <input matInput formControlName="fileNumber" type="text"/>
          </mat-form-field>
        </div>
      </div>
    }
    @if (validationEnabled && !formValid) {
      <p class="card-text mat-text-warn" (click)="toggleFullErrorMessage()">Please correct any errors highlighted in red on the form.</p>
    }
    @if (showFullErrorMessage) {
      <ul class="full-error-message">
        @for (error of fullFormError; track $index) {
          <li class="card-text mat-text-warn">{{error.key}}: {{error.control.errors | json}}</li>
        }
      </ul>
    }
    </form>
  }
  </mat-card-content>
  <mat-card-actions>
    <a mat-flat-button [routerLink]="[backButtonRoute]">Cancel</a>
    <button mat-flat-button color="primary" (confirm)="save()" appConfirmationDialog [confirmMessage]="'Are you sure you wish to add this patient to the system?'"
            *appPermissionRequired="'Clinical.Patients.Write'; condition: !isEditForm">Create Patient
    </button>
    <button mat-flat-button color="primary" (confirm)="save()" appConfirmationDialog [confirmMessage]="'Are you sure you wish to update this patient?'"
            *appPermissionRequired="'Clinical.Patients.Write'; condition: isEditForm">Save Changes
    </button>
  </mat-card-actions>
</mat-card>
